import React, { useState } from "react";

import type { Schedule, SolverPhase } from "@/types.ts";
import type { SolverPhaseEmployeesController, SolverPhaseEmployeesProps } from "@/components/sections/SolverPhaseEmployees.types.tsx";


export function buildSolverPhaseEmployeesController(
    phase: SolverPhase | undefined,
    phaseId: string | undefined,
    schedule: Schedule | null
): SolverPhaseEmployeesController {

    const [editData, setEditData] = useState({ ...{}, ...phase });
    const editMapOfEmployeeSettings = editData.mapOfEmployeeSettings || {};
    var listOfUIEmployees: SolverPhaseEmployeesController["viewData"]["listOfUIEmployees"] = [];

    schedule?.employees?.forEach((employee) => {
        listOfUIEmployees.push({
            name: employee.name || employee.userId,
            id: employee.userId,
            value: (editMapOfEmployeeSettings[employee.userId] || {}).apply === true
        });
    });

    const selectedCount = listOfUIEmployees.filter((item) => item.value).length;

    //@ Restriction is carried by the map itself: an empty map means every employee, including the ones hired later.
    const restrictedCount = Object.values(editMapOfEmployeeSettings).filter((settings) => settings?.apply === true).length;

    const viewData: SolverPhaseEmployeesController["viewData"] = {
        phaseId: phaseId,
        phase: phase,
        isNew: !(!!phase && !!phaseId),
        listOfUIEmployees: listOfUIEmployees,
        isAll: restrictedCount === 0,
        selectedCount: selectedCount
    }

    return {
        setEditData,
        editData,
        viewData
    }
}


/**
 * Main component
 * @param param0
 * @returns
 */
const SolverPhaseEmployees: React.FC<SolverPhaseEmployeesProps> = (props) => {

    const ctrl = props.controller;
    const viewData = ctrl.viewData;

    return (
        <div className="text-gray-700">
            <p className="text-sm text-gray-500 mb-2">
                {viewData.isAll
                    ? "Aucune restriction : la phase s'applique à tout le monde."
                    : `La phase sera limitée aux ${viewData.selectedCount} personne(s) sélectionnée(s).`}
            </p>

            <div className="border-1 border-gray-300 rounded-sm max-h-96 overflow-y-auto py-1">
                <label className="flex items-center gap-2 px-4 py-1 cursor-pointer hover:bg-gray-50">
                    <input
                        type="checkbox"
                        checked={viewData.isAll}
                        onChange={props.onAllEmployeesClick}
                        className="h-4 w-4 accent-blue-600 cursor-pointer"
                    />
                    <span className="font-medium text-sm text-gray-900">Tous</span>
                </label>

                <div className="border-b border-b-gray-200 my-1" />

                {
                    viewData.listOfUIEmployees.map((item) => {
                        return <label
                            key={item.id}
                            className="flex items-center gap-2 px-4 py-1 cursor-pointer hover:bg-gray-50"
                        >
                            <input
                                type="checkbox"
                                checked={item.value}
                                onChange={() => props.onEmployeeClick(item.id)}
                                className="h-4 w-4 accent-blue-600 cursor-pointer"
                            />
                            <span className="text-sm text-gray-700">{item.name}</span>
                        </label>
                    })
                }
            </div>
        </div>
    );
};

export default SolverPhaseEmployees;
